module.exports = "<!-- <header class=\"header\">\n    <nav class=\"nav nav--main\">\n        <a href=\"/\" class=\"uppercase font--medium\">Tous les chantiers</a>\n        <a class=\"logo\" href=\"/\"><img src=\"./assets/img/logo.svg\" alt=\"\"></a>\n        <a href=\"\" class=\"link--gradient\">Déconnexion</a>  \n    </nav>\n</header> -->\n<main class=\"page min-vh\">\n\t<router-outlet></router-outlet>\n    <vq-modal></vq-modal>\n    <vq-alert></vq-alert>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = ./src/app/layout/layout.component.html
// module chunks = main